import type { ChannelMask } from '../hooks/useChannelsForSettings'

type ChannelBanner = NonNullable<ChannelMask['banners']>[number]

export enum Status {
  Locked = 'locked',
  RequiresRefreshing = 'requiresRefreshing',
  Active = 'active',
}

type ChannelStatus = {
  status: Status
}

type ChannelStatusProps = {
  channel: ChannelMask
}

export const isChannelRequiringRefresh = (channel: ChannelMask): boolean =>
  channel.banners?.some(
    (banner: ChannelBanner) =>
      banner === 'tiktokUpgrade' ||
      banner === 'pinterestUpgrade' ||
      banner === 'linkedinUpgrade' ||
      banner === 'igLoginRefresh',
  ) ||
  (channel.service === 'twitter' && channel.apiVersion !== '2')

export const getChannelStatus = ({
  channel,
}: ChannelStatusProps): ChannelStatus => {
  const needsRefreshing = isChannelRequiringRefresh(channel)

  let status = Status.RequiresRefreshing
  if (channel.isLocked) {
    status = Status.Locked
  } else if (!needsRefreshing && !channel.isDisconnected) {
    status = Status.Active
  }

  return {
    status,
  }
}
